export default __webpack_public_path__ + "static/media/GT.3207543f.svg";